export default __webpack_public_path__ + "static/media/cake7.0c0db81d.jpeg";